import type { FC, ReactNode } from 'react';

import { ContextualCommentTargetContext } from './context';
import type { ContextualCommentTargetContextValue } from './context';

interface ContextualCommentTargetProviderProps extends ContextualCommentTargetContextValue {
    children: ReactNode;
}

const ContextualCommentTargetProvider: FC<ContextualCommentTargetProviderProps> = ({
    baseTarget,
    children,
    resource,
    resetTarget,
    setTarget,
    target,
}) => (
    <ContextualCommentTargetContext.Provider value={{ baseTarget, resource, resetTarget, setTarget, target }}>
        {children}
    </ContextualCommentTargetContext.Provider>
);

export default ContextualCommentTargetProvider;
